import PropTypes from "prop-types"
import React from "react"
import { opensInPlace, useBillingSheets } from "src/main/Billing/Sheets/context"

const PaymentLink = ({ paymentTxnId, href, className, children }) => {
  const sheets = useBillingSheets()

  return (
    <a
      href={href}
      className={className}
      onClick={(event) => {
        if (!sheets || !opensInPlace(event)) return

        event.preventDefault()
        sheets.openPayment(paymentTxnId)
      }}
    >
      {children}
    </a>
  )
}

PaymentLink.propTypes = {
  paymentTxnId: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default PaymentLink
